// Vendor libraries
import { createReducer, on } from '@ngrx/store';
import { ScatterPlotChartOptionValue } from 'ChartApp/ts/enums/scatter-plot-common.enum';
// Action imports
import { setNameInLegend } from './chart-options.actions';
import { setScatterPlot } from '../scatter-plot.actions';
// Constants
import { NAME_IN_LEGEND_DEFAULT } from 'ChartApp/ts/apps/scatter-plot/constants';
export const nameInLegend = createReducer(NAME_IN_LEGEND_DEFAULT, on(setNameInLegend, (state, action) => {
    return action.nameInLegend;
}), on(setScatterPlot, (state, action) => {
    return action.scatterPlot[ScatterPlotChartOptionValue.nameInLegend];
}));
